import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import Typography from '~/components/core/Atomic/Typography';
import cn from '~/Utils/cn';

import colors from '../../../../assets/colors.module.scss';

const VARIANTS = {
  REGULAR: 'regular',
  MEDIUM: 'medium',
  SEMI_BOLD: 'semi-bold',
};

const WEIGHT_TO_NUM = {
  [VARIANTS.REGULAR]: 400,
  [VARIANTS.MEDIUM]: 500,
  [VARIANTS.SEMI_BOLD]: 600,
};

const useStyles = makeStyles()((_theme, { variant }) => ({
  root: {
    fontWeight: WEIGHT_TO_NUM[variant],
    fontSize: 10,
    color: variant === VARIANTS.REGULAR && colors.textSecondary,
  },
}));

const Label = ({ className, variant = VARIANTS.REGULAR, children }) => {
  const { classes: displayClasses } = useStyles({ variant });

  return <Typography className={cn(displayClasses.root, className)}>{children}</Typography>;
};

Label.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  children: PropTypes.node.isRequired,
};

Label.VARIANTS = VARIANTS;

export default Label;
